import { AddressComponent } from './address/address.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '@app/modules/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from '@app/pipes/pipes.module';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { MapsService } from '@app/services/maps/maps.service';
import { groupByCategoryPipe } from '@app/pipes/groupByCategory/groupByCategory.pipe';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { TabsModule } from 'ngx-bootstrap';
import { OptionsSuppModalComponent } from '@app/modules/modals/options-supp-modal/options-supp-modal.component';
import { TicketComponent } from '@app/components/ticket/ticket.component';
import { ProductMenuModule } from '@app/components/product-menu/product-menu.module';
import { ToastContainerModule, ToastrModule } from 'ngx-toastr';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        AccordionModule.forRoot(),
        TooltipModule.forRoot(),
        SharedModule,
        PipesModule,
        AbsolutePathModule,
        TabsModule.forRoot(),
        ProductMenuModule,
        ToastContainerModule,
        ToastrModule.forRoot({
            preventDuplicates: true,
        }),
    ],
    declarations: [
        PersonalizeProductComponent,
        MenuModalComponent,
        AddressComponent,
        groupByCategoryPipe,
        OptionsSuppModalComponent,
        // ToastContainerDirective,
        TicketComponent
    ],
    exports: [
        PersonalizeProductComponent,
        OptionsSuppModalComponent,
        TicketComponent
    ],
    entryComponents: [
        PersonalizeProductComponent,
        MenuModalComponent,
        AddressComponent,
        OptionsSuppModalComponent,
        TicketComponent
    ],
    providers: [
        MapsService,
        groupByCategoryPipe
    ]
})

export class ModalsModule {

}
